import type { TitleReviewForm } from "~/types/forms/titleReview";
import { Rating } from "~/src/api";
import {
  getRatingPostBody,
  getRatingPutBody,
} from "~/src/forms/titleReview/common";

export async function createReview(form: TitleReviewForm) {
  const token = await getTokenOrThrow();
  return await Rating.create(getRatingPostBody(form), token);
}
